const { default: axios } = require("axios");
const { managementCosting } = require("@/networking/urlmanager");
const { washPoint } = require("../networking/urlmanager");
const {haversineDistance}=require('./recomendation/haversineDistance.js')
const similarity  = require("similarity");
const { getTokenSafely, validateToken } = require("./recomendation/tokenHelper");


// Sabitler - global değişkenler yerine
const constants = {
  kilometerForFuel: 0.32, // Yakıt tüketim oranı
  adblueUsePercentage: 0.023, // AdBlue kullanım oranı
  vehiclePerwhellCount: 12, // Araç başına lastik sayısı
  engineConsumption: 40, // Motor yağı tüketimi (litre)
  fuelFilterConsumption: 1, // Yakıt filtresi tüketimi
  separFilterConsumption: 1, // Seperatör filtresi tüketimi
  oilFilterConsumption: 1, // Yağ filtresi tüketimi
  airFilterConsumption: 1, // Hava filtresi tüketimi
  airDryerFilterConsumption: 1, // Hava kurutucu filtresi tüketimi
  brakePadConsumptionPrice: 5, // Fren balatası tüketimi
  diskPriceConsumptionPrice: 5, // Disk tüketimi
  clutchConsumptionPrice: 1, // Debriyaj tüketimi
  trailerInspection: 0, // Römork muayene ücreti
  trailerInsurance: 0, // Römork sigorta ücreti
  investmentCost: 0, // Yatırım maliyeti
  // Periyotlar
  periot: {
    km_40000: 40000,
    km_80000: 80000,
    km_120000: 120000,
    km_150000: 150000,
    km_180000: 180000,
    km_280000: 280000
  }
};


function replaceToMoney(val) {
  return val.includes(",") ? Number(val.replace(",", ".")) : Number(val);
}

let calculatorDataCache = {
  costingData: null,
  washingPoints: null,
  lastFetch: null,
  fetchPromise: null,
};


async function fetchAndCacheData(token) {
  // Token validation - Eğer token geçersizse localStorage'dan oku
  let validToken = token;

  // Eğer parametre olarak gelen token geçersizse, localStorage'dan al
  if (!token || token === 'undefined' || token === 'null' || typeof token !== 'string' || token.trim() === '') {
    console.warn('⚠️ [fetchAndCacheData] Parametre token geçersiz, localStorage\'dan okunuyor...');
    validToken = getTokenSafely();
  }

  // Artık validToken'ı validate et
  validateToken(validToken, 'fetchAndCacheData');

  // If there's an ongoing fetch, wait for it
  if (calculatorDataCache.fetchPromise) {
    return calculatorDataCache.fetchPromise;
  }

  // If cache is valid (less than 5 minutes old), use it
  if (
    calculatorDataCache.costingData &&
    calculatorDataCache.lastFetch &&
    Date.now() - calculatorDataCache.lastFetch < 5 * 60 * 1000
  ) {
    return {
      costingData: calculatorDataCache.costingData,
      washingPoints: calculatorDataCache.washingPoints,
    };
  }


  calculatorDataCache.fetchPromise = Promise.all([
    axios.get(managementCosting.getAll, {
      headers: {
        Authorization: "Bareer " + validToken,
      },
    }),
    axios.get(washPoint.getWashingLocations, {
      headers: {
        Authorization: "Bareer " + validToken,
      },
    }),
  ])
    .then(([costingResponse, washingPointsResponse]) => {
      const result = {
        costingData: costingResponse.data.data,
        washingPoints: washingPointsResponse.data.data,
      };

      calculatorDataCache.costingData = result.costingData;
      calculatorDataCache.washingPoints = result.washingPoints;
      calculatorDataCache.lastFetch = Date.now();
      calculatorDataCache.fetchPromise = null;

      return result;
    })
    .catch((error) => {
      calculatorDataCache.fetchPromise = null;

      // 401 Unauthorized hatası - önbelleği temizle
      if (error.response && error.response.status === 401) {
        console.error('🔴 401 Unauthorized: Token geçersiz, önbellek temizleniyor');
        calculatorDataCache.costingData = null;
        calculatorDataCache.washingPoints = null;
        calculatorDataCache.lastFetch = null;

        // Kullanıcıyı bilgilendir (error objesini zenginleştir)
        const authError = new Error('Authentication failed: Invalid or expired token');
        authError.isAuthError = true;
        authError.statusCode = 401;
        authError.originalError = error;
        throw authError;
      }

      // Diğer hatalar
      throw error;
    });

  return calculatorDataCache.fetchPromise;
}


/**
 * En uygun yıkama noktasını bulur - Optimize edilmiş hali
 * @param {Object} vehicle - Araç bilgileri
 * @param {Object} order - Sipariş bilgileri
 * @param {Array} washingPoints - Yıkama noktaları listesi
 * @param {number} motorinPrice - Motorin fiyatı
 * @return {Object} - En uygun yıkama noktası ve maliyeti
 */
function findBestWashPoint(vehicle, order, washingPoints, motorinPrice) {
   // Eğer araç Kiralıksa ve bir polygona dahilse yıkama maliyeti oluşmasın
   let isVehicleRentAndIncludePolygon = vehicle?.haveType == 1 && vehicle?.polygonId && (vehicle?.recomendation.isWashing == 1);  
  
  // 1. Erken çıkış kontrolleri - tek bir if içinde birleştirerek performans artışı
  if (!vehicle?.recomendation?.isWashing || vehicle.recomendation.isWashing !== 1 || isVehicleRentAndIncludePolygon) {
    if(vehicle){ 
      vehicle.isVehicleRentAndIncludePolygon = isVehicleRentAndIncludePolygon;
      order.isVehicleRentAndIncludePolygon = isVehicleRentAndIncludePolygon;
    }
    return { totalWashPriceCost: 0, washPointName: null, distance: 0 ,isVehicleRentAndIncludePolygon};
  }

  // 2. Eşleşme eşiği - sabit
  const SIMILARITY_THRESHOLD = 0.9;
  
  // 3. Araç koordinatlarını bir kere hesapla ve dönüştür
  const vehicleLat = typeof vehicle.latitude === "number" ? vehicle.latitude : Number(vehicle.latitude);
  const vehicleLng = typeof vehicle.longitude === "number" ? vehicle.longitude : Number(vehicle.longitude);
  
  // 4. Sipariş koordinatlarını bir kere hesapla
  let orderLat = null;
  let orderLng = null;
  
  if (order) {
    // Kod okunabilirliği için ternary operatörlerini ayırarak
    orderLat = order.startLat ? Number(order.startLat) : 
               (order.outpointLat ? Number(order.outpointLat) : 
               (order.fillingLatitude ? Number(order.fillingLatitude) : null));
    
    orderLng = order.startLng ? Number(order.startLng) : 
               (order.outpointLng ? Number(order.outpointLng) : 
               (order.fillingLongitude ? Number(order.fillingLongitude) : null));
  }
  
  // 5. Ürün adı için - isSequentialTrue mantığını koruyoruz
  let vehicleProductName = vehicle?.lastProduct;
  if (vehicle?.isSequentialTrue) {
    vehicleProductName = vehicle?.productId;
  }
  
  // Veri validasyonu - her kontrol ayrı yapılarak regresyon önleniyor
  if (!vehicleProductName || !washingPoints || washingPoints.length === 0) {
    return { totalWashPriceCost: 0, washPointName: null, distance: 0 };
  }

  // Ürün adı için string'i önceden hazırla - trim işlemini bir kere yap
  const vehicleProductNameTrimmed = vehicleProductName.trim();
  
  // 6. En iyi noktayı bulmak için gerekli değişkenler
  let bestWashPoint = null;
  let shortestDistance = Infinity;
  
  // İlk filtre uygulaması - uygun ürünleri içeren yıkama noktaları
  // Optimize edilmiş geçiş ile doğrudan filtrelenmiş noktaları topluyoruz
  const filteredWashPoints = [];
  
  for (let i = 0; i < washingPoints.length; i++) {
    const point = washingPoints[i];
    
    // Ürün eşleşmesi kontrolü
    let matchingFound = false;
    
    // Ürün özelliklerini kontrol et
    for (let j = 0; j < point.properties.length; j++) {
      const item = point.properties[j];
      
      // Ürün adı eşleşmesi kontrolü
      if (item.productName && 
          similarity(item.productName.trim(), vehicleProductNameTrimmed) >= SIMILARITY_THRESHOLD) {
        matchingFound = true;
        break; // Bir eşleşme bulduk, döngüyü sonlandırabiliriz
      }
    }
    
    // Eşleşme yoksa sonraki yıkama noktasına geç
    if (!matchingFound) continue;
    
    // Eşleşen noktayı filtrelenmiş listeye ekle
    filteredWashPoints.push(point);
  }
  
  if (filteredWashPoints.length === 0) {
    if(vehicle) vehicle.washPointNotExist=true;
    return { totalWashPriceCost: 0, washPointName: null, distance: 0, washPointNotExist: true };
  }

  // Yıkama noktalarını mesafe ve maliyete göre değerlendir
  const ratedWashPoints = [];
  
  for (let i = 0; i < filteredWashPoints.length; i++) {
    const point = filteredWashPoints[i];
    
    // Koordinatları sayısal değere tek seferde dönüştür
    const pointLat = Number(point.latitude);
    const pointLng = Number(point.longitude);
    
    // Araç ile yıkama noktası arasındaki mesafe
    const vehicleToWashDistance = haversineDistance(
      { lat: vehicleLat, lng: vehicleLng },
      { lat: pointLat, lng: pointLng }
    );
    
    // Sipariş başlangıç noktası ile yıkama noktası arasındaki mesafe
    let orderToWashDistance = 0;
    if (orderLat !== null && orderLng !== null) {
      orderToWashDistance = haversineDistance(
        { lat: orderLat, lng: orderLng },
        { lat: pointLat, lng: pointLng }
      );
    }
    
    // Toplam mesafe
    const totalDistance = vehicleToWashDistance + orderToWashDistance;
    
    // Ürün ID'sine göre fiyat hesaplaması - orijinal mantık korunuyor
    const matchingProperties = point.properties.filter(
      item => order && item.productId === order.productId
    );
    
    // Ortalama fiyat hesaplama - orijinal mantık korunuyor
    const averagePrice = matchingProperties.length > 0
      ? matchingProperties.reduce((sum, item) => sum + item.price, 0) / matchingProperties.length
      : 0;
    
    ratedWashPoints.push({
      ...point,
      distance: totalDistance,
      cost: averagePrice
    });
    
    // Optimize edilmiş versiyondaki gibi en iyi noktayı doğrudan burada da bulabiliriz
    if (totalDistance < shortestDistance) {
      shortestDistance = totalDistance;
      bestWashPoint = {
        ...point,
        distance: totalDistance,
        cost: averagePrice
      };
    }
  }
  
  // En iyi nokta bulunamadıysa (genellikle olmamalı, ama güvenlik için)
  if (!bestWashPoint && ratedWashPoints.length > 0) {
    bestWashPoint = ratedWashPoints.sort((a, b) => a.distance - b.distance)[0];
  }
  
  if (!bestWashPoint) {
    return { totalWashPriceCost: 0, washPointName: null, distance: 0 };
  }
  
  // Toplam maliyet: mesafe x yakıt tüketimi x yakıt fiyatı + yıkama maliyeti
  // constants.kilometerForFuel kullanımını koruyoruz - regresyon önleme
  const totalWashPriceCost = bestWashPoint.distance * constants.kilometerForFuel * motorinPrice + bestWashPoint.cost;
  
  return {
    totalWashPriceCost,
    washPointName: bestWashPoint.name,
    distance: bestWashPoint.distance
  };
}

/**
 * Maliyet hesaplama ana fonksiyonu
 */
async function calculator(
  token,
  vehicleCount = 1,
  totalYearKilometer = 1,
  vehicle = null,
  order = null,
  totalMontlyKilometer = 0,
  hgsPrice = 0,
  isAmortisman = true,
  isOneWay = true,
  dayCount = 0,
  hour = 24,
  {costingData, washingPoints,washData}={},
  transitionCount=0
) {
  // Performans ölçümü
  const startTime = Date.now();
  
  try {
    // Veri al
    if (!washData) {
     //console.log("washDataYok",{costingData, washingPoints,washData})
      const result = await fetchAndCacheData(token);
      costingData = result.costingData;
      washingPoints = result.washingPoints;
    }
    // Veriyi doğrula
    if (!costingData || costingData.length < 20) {
      throw new Error("Geçersiz fiyat verisi");
    }
    
    // Fiyat verilerini alma ve dönüştürme (tek seferde daha okunabilir)
    const prices = {
      insurance: replaceToMoney(costingData[0]?.price),
      trafficInsurance: replaceToMoney(costingData[1]?.price),
      mtv: replaceToMoney(costingData[2]?.price),
      mtv2: replaceToMoney(costingData[3]?.price),
      inspection: replaceToMoney(costingData[4]?.price),
      
      whell: replaceToMoney(costingData[5]?.price),
      engineOil: replaceToMoney(costingData[6]?.price),
      fuelFilter: replaceToMoney(costingData[7]?.price),
      separFilter: replaceToMoney(costingData[8]?.price),
      oilFilter: replaceToMoney(costingData[9]?.price),
      airFilter: replaceToMoney(costingData[10]?.price),
      airDryerFilter: replaceToMoney(costingData[11]?.price),
      
      brakePad: replaceToMoney(costingData[12]?.price),
      brakePadChange: replaceToMoney(costingData[13]?.price),
      
      disk: replaceToMoney(costingData[14]?.price),
      diskChange: replaceToMoney(costingData[15]?.price),
      
      clutch: replaceToMoney(costingData[16]?.price),
      clutchChange: replaceToMoney(costingData[17]?.price),
      
      periodicMaintenance: replaceToMoney(costingData[18]?.price),
      driverWage: replaceToMoney(costingData[19]?.price),
      motorin: replaceToMoney(costingData[20]?.price),
      
      adblue: replaceToMoney(costingData[22]?.price),
      depreciation: replaceToMoney(costingData[23]?.price),
      contactInformation: replaceToMoney(costingData[24]?.price),
      washingCostPerOperation:replaceToMoney(costingData[25]?.price),//OPERASYON BAŞI YIKAMA MALİYETİ
      otherPersonnelPerVehicle: replaceToMoney(costingData[26]?.price)
    };

    // Yıkama noktası hesaplama
    const washInfo = findBestWashPoint(vehicle, order, washingPoints, prices.motorin);
    
    // Hesaplama performansını iyileştirmek için destructuring
    const { periot } = constants;
    
    // 1. Toplam yakıt maliyeti = toplam km * yakıt tüketimi * yakıt birim fiyatı
    const fuelTotalPrice = totalMontlyKilometer * constants.kilometerForFuel * prices.motorin;
    
    // 2. Toplam AdBlue maliyeti = toplam km * AdBlue tüketimi * AdBlue birim fiyatı
    const totalAdbluePrice = totalMontlyKilometer * prices.adblue * constants.adblueUsePercentage;

    // 3. Lastik maliyeti = (lastik fiyatı * lastik sayısı / kullanım ömrü) * toplam km
    const totalWhellPrice = ((prices.whell * constants.vehiclePerwhellCount) / periot.km_150000) * totalMontlyKilometer;

    // 4. Motor yağı maliyeti = (yağ fiyatı * yağ miktarı / değişim periyodu) * toplam km
    const totalEngineOilPrice = ((prices.engineOil * constants.engineConsumption) / periot.km_120000) * totalMontlyKilometer;

    // 5. Toplam filtre maliyeti - tüm filtreler için tek formül
    const filterTypes = [
      { price: prices.fuelFilter, consumption: constants.fuelFilterConsumption },
      { price: prices.separFilter, consumption: constants.separFilterConsumption },
      { price: prices.oilFilter, consumption: constants.oilFilterConsumption },
      { price: prices.airFilter, consumption: constants.airFilterConsumption },
      { price: prices.airDryerFilter, consumption: constants.airDryerFilterConsumption }
    ];
    
    const TotalfilterPrice = filterTypes.reduce((total, filter) => {
      return total + ((filter.price * filter.consumption) / periot.km_120000) * totalMontlyKilometer;
    }, 0);

    // 6. Balata maliyeti
    const totalBrakePadPrice = ((prices.brakePad * constants.brakePadConsumptionPrice + prices.brakePadChange) / periot.km_80000) * totalMontlyKilometer;

    // 7. Disk maliyeti
    const totalDiskPrice = ((prices.disk * constants.diskPriceConsumptionPrice + prices.diskChange) / periot.km_180000) * totalMontlyKilometer;
    
    // 8. Debriyaj maliyeti
    const totalClutchPrice = ((prices.clutch * constants.clutchConsumptionPrice + prices.clutchChange) / periot.km_280000) * totalMontlyKilometer;
    
    // 9. Periyodik bakım maliyeti
    const totalperiodicMaintenanceCost = (prices.periodicMaintenance / periot.km_40000) * totalMontlyKilometer;
    
    // 10. Resmi giderler (aylık)
    const totalTrafficInsurancePriceAndinsurancePrice = (
      prices.trafficInsurance +
      prices.insurance +
      prices.mtv +
      prices.mtv2 +
      prices.inspection +
      constants.trailerInspection +
      constants.trailerInsurance
    ) / 12;

    // 11. Diğer maliyetler
    const otherCost = prices.contactInformation + prices.otherPersonnelPerVehicle + prices.washingCostPerOperation;
    
    // 12. Toplam maliyet hesaplama - değişken maliyetler
    let totalCost = fuelTotalPrice +
      totalAdbluePrice +
      totalWhellPrice +
      totalEngineOilPrice +
      TotalfilterPrice +
      totalBrakePadPrice +
      totalDiskPrice +
      totalClutchPrice +
      totalperiodicMaintenanceCost +
      hgsPrice;
    
    // 13. Sabit maliyetleri ekle - tek/çift yön durumuna göre
    const dailyMultiplier = isOneWay ? 1 : 2;
    
    // Tüm günlük maliyetleri tek seferde hesapla
    const dailyCosts = [
      { cost: totalTrafficInsurancePriceAndinsurancePrice / 30, apply: true },
      { cost: transitionCount > 0 ? otherCost : otherCost / 30 , apply: true,transitionNotCalculate:true },
      { cost: constants.investmentCost / 30, apply: true },
      { cost: prices.driverWage / 30, apply: true },
      { cost: prices.depreciation / 30, apply: isAmortisman}
    ];

    // Günlük maliyetleri toplama ekle
    dailyCosts.forEach(item => {
      //totalCost += item.cost * dayCount;
      //Eğer aylık sefer girilmişse bu parameterlerin dayCount olarak değil aylık olarak hesaplanması
     if(item.apply){ 
        if(item?.transitionNotCalculate){
          totalCost += item.cost * dayCount ;
        }else{
          totalCost += item.cost * (transitionCount >= 1 ? (1 * 30) : dayCount );
        }
      }
    });
    
    // Performans ölçümü sonlandır
    const endTime = Date.now();
    
    // Sonuçları döndür
    return {
      total: totalCost.toFixed(2),
      fuelTotalPrice,
      totalAdbluePrice,
      totalWhellPrice,
      totalEngineOilPrice,
      TotalfilterPrice,
      totalBrakePadPrice,
      totalDiskPrice,
      totalClutchPrice,
      totalperiodicMaintenanceCost,
      totalTrafficInsurancePriceAndinsurancePrice,
      totalWashPriceCost: washInfo.totalWashPriceCost.toFixed(2),
      washPointName: washInfo.washPointName,
      otherCost,
      depreciationPrice: prices.depreciation,
      driverWagePrice: prices.driverWage,
      distanceWithWashing: washInfo.distance,
      washPointNotExist: washInfo.washPointNotExist||false,
    };
  } catch (error) {
    console.error("Calculator error:", error);
    // Hata durumunda varsayılan değerler döndür
    return {
      total: "0.00",
      totalWashPriceCost: "0.00",
      washPointName: null,
      distanceWithWashing: 0
    };
  }
}
module.exports = {
  calculator,fetchAndCacheData
};
